import { on } from '@ngrx/store';
import { NutritionActions, AsyncActions } from './nutrition.actions';
import {asyncActionState, AsyncActionState} from '@emm/core/util/async-action-state';
import {NutritionAssignment, NutritionLocation} from '@emm/core/models/nutrition.model';
import {withLoadables} from '@emm/core/util/ngrx.util';

export const nutritionFeatureKey = 'nutrition';

export interface NutritionState extends AsyncActionState {
    assignment: NutritionAssignment;
    assignments: NutritionAssignment[];
    centerLoading: boolean;
    date: number,
    location: NutritionLocation;
    locationSetType: string;
    profileOptions: number[]
    rightLoading: boolean;
}

export const initialState: NutritionState = {
    assignment: null,
    assignments: [],
    centerLoading: false,
    date: null,
    location: null,
    locationSetType: null,
    profileOptions: [1],
    rightLoading: false,
    ...asyncActionState.initial
};

const { loadActions, successActions, errorActions } = AsyncActions;

export const nutritionReducer = withLoadables<NutritionState>({
    errorActions,
    loadActions,
    successActions
})(
    initialState,



    on(NutritionActions.initNutrition, () => ({
        ...initialState
    })),



    on(NutritionActions.selectNutritionLocation, (state: NutritionState, { location }) => ({
        ...state,
        location
    })),



    on(NutritionActions.selectNutritionLocationSetType, (state: NutritionState, { locationSetType }) => ({
        ...state,
        centerLoading: true,
        locationSetType
    })),



    on(NutritionActions.selectNutritionLocationSetTypeSuccess, (state: NutritionState) => ({
        ...state,
        centerLoading: false
    })),



    on(NutritionActions.selectAssignment, (state: NutritionState, { assignment }) => ({
        ...state,
        assignment
    })),



    on(NutritionActions.selectDate, (state: NutritionState, { date }) => ({
        ...state,
        date
    })),



    on(NutritionActions.unselectLocation, (state: NutritionState) => ({
        ...state,
        assignment: null,
        assignments: [],
        location: null,
        locationSetType: null
    })),



    on(NutritionActions.loadProfileOptionsSuccess, (state: NutritionState, { profileOptions }) => ({
        ...state,
        profileOptions
    })),



    on(NutritionActions.loadAssignmentsSuccess, (state: NutritionState, { assignments }) => ({
        ...state,
        centerLoading: false,
        assignments
    })),



    on(NutritionActions.saveLocationAssignmentSuccess, (state: NutritionState, { apiData }) => {
        let found = false;
        const assignments = state.assignments.map(assignment => {
            if (assignment.effectiveDate === apiData.effectiveDate) {
                found = true;
            }
            return {
                ...assignment,
                profile: assignment.effectiveDate === apiData.effectiveDate ? apiData.profile : assignment.profile
            }
        });
        if (!found) {
            assignments.push(apiData);
        }
        return {
            ...state,
            assignment: {
                ...apiData,
                effectiveDate: apiData.effectiveDate
            },
            assignments: assignments.sort((a, b) => a.effectiveDate > b.effectiveDate ? 1 : -1),
            rightLoading: false
        };
    })



);
